<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Paquetes - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
         
                <b-col sm="12" md="8">
                </b-col>

                <b-col sm="12" md="3">
                  <b-form-group label=".">
                    <b-input-group>
                    <b-form-input @keyup.enter="ListPackage" v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListPackage"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col sm="6" md="1">
                  <b-form-group label=".">
                    <b-link  v-if="Permission('PackageAdd')" class="btn form-control btn-primary"  :to="{ path: '/paquete/nuevo' }" append ><i class="fas fa-file"></i></b-link>
                  </b-form-group>
                </b-col>
            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="10%" class="text-center">Imagen</th>
                    <th width="45%" class="text-center">Nombre</th>
                    <th width="10%" class="text-center">Categoria</th>
                    <th width="8%" class="text-center">Precio</th>
                    <th width="8%" class="text-center">Estado</th>
                    <th width="7%" class="text-center">Favorito</th>
                    <th width="10%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center">
                      <b-img thumbnail fluid :src="url_base+item.image" alt="Image 1"></b-img>
                    </td>
                    <td class="text-left"> {{ item.title_es  }}</td>
                    <td class="text-left"> {{ item.category_name  }}</td>
                    <td class="text-center"> <span>{{ item.price_es  }} PEN</span> <br> <span>{{ item.price_en  }} USD</span></td>
                    <td class="text-center">
                      <b-button @click="State(item.id_package)" type="button" class="text-center" :variant="item.state == 1 ? 'success':'danger'">
                        <span v-if="item.state == 1">Activo</span>
                        <span v-if="item.state == 0">Inactivo</span>
                      </b-button>
                      
                    </td>
                    <td class="text-center">   
                      <b-button @click="Favorite(item.id_package)" type="button" class="text-center" :variant="item.favorite == 1 ? 'primary':'warning'"><i class="fas fa-star"></i></b-button>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="Permission('PackageEdit')" @click="EditPackage(item.id_package)" >Editar</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('PackageView')" @click="ViewPackage(item.id_package)" >Ver</b-dropdown-item>
                        <b-dropdown-item  v-if="Permission('PackageDelete')" @click="ConfirmDeletePackage(item.id_package)" >Eliminar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListPackage" :total-rows="rows" :per-page="perPage" align="center" ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "UsuarioList",
  components:{
    vSelect,
  },
  data() {
    return {
      module:'Package',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      search: "",
    };
  },
  mounted() {
    this.ListPackage();
  },
  methods: {
    ListPackage,
    EditPackage,
    ViewPackage,
    ConfirmDeletePackage,
    DeletePackage,
    Permission,
    Favorite,
    State,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function ListPackage() {

  let search = this.search == "" ? "all" : this.search;
  let me = this;
  let url = this.url_base + "package/list/" + search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditPackage(id_package) {
  this.$router.push({
    name: "PackageEdit",
    params: { id_package: je.encrypt(parseInt(id_package)) },
  });
}

// Ver Usuario
function ViewPackage(id_package) {
  this.$router.push({
    name: "PackageView",
    params: { id_package: je.encrypt(parseInt(id_package)) },
  });
}

// Confirmar eliminar
function ConfirmDeletePackage(id_package) {
  Swal.fire({
    title: "Esta seguro de eliminar el paquete?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeletePackage(id_package);
    }
  });
}

// eliminar usuario
function DeletePackage(id_package) {
  let me = this;
  let url = this.url_base + "package/delete/" + id_package;
  axios({
    method: "delete",
    url: url,
    headers: {token: this.token, module: this.module,role: 4,},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_package).indexOf(response.data.result.id_package);
        me.data_table.splice(index, 1);
        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

function Favorite(id_package) {
  let me = this;
  let url = this.url_base + "package/favorite/" + id_package;
  axios({
    method: "get",
    url: url,
    headers: {token: this.token, module: this.module,role: 3},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_package).indexOf(response.data.result.id_package);
        me.data_table[index].favorite = response.data.result.favorite;
        // Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

function State(id_package) {
  let me = this;
  let url = this.url_base + "package/state/" + id_package;
  axios({
    method: "get",
    url: url,
    headers: {token: this.token, module: this.module,role: 3},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_package).indexOf(response.data.result.id_package);
        me.data_table[index].state = response.data.result.state;
        // Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}
// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
